import { render, staticRenderFns } from "./LeaveApprovalSettingsForm.vue?vue&type=template&id=24351105&"
import script from "./LeaveApprovalSettingsForm.vue?vue&type=script&lang=js&"
export * from "./LeaveApprovalSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports